import React from 'react';
import { NavLink } from 'react-router-dom';

const ArtisanPassion = () => {
    return (
        <div className="artisan_passion">
            <h2>Denis, un artisan passionné</h2> 
            <p>C'est en janvier 2003 que l'<strong>entreprise artisanale DKD</strong> voit le jour. Au départ, une entreprise d'électricité générale, les demandes clients l'ont fait évoluer au fil du temps.</p>
            <p>Au départ actif sur le secteur de Schirrhein, Schirrhoffen, le bouche à oreille a permis d'agrandir la zone de chalandise de l'<strong>entreprise artisanale DKD</strong>.</p>
            <p>DKD possède le <span>label Artisan confiance depuis plus de cinq ans</span> maintenant. De plus, l'entreprise possède la mention « Reconnu Garant de l'Environnement » (RGE) depuis l'année 2016.</p>
            <NavLink to="/realisations" exact className="hover">
                <button>Découvrir les réalisations de DKD</button>
            </NavLink>
        </div>
    );
};

export default ArtisanPassion;